import {CUSTOM_OPTION_OPEN, CUSTOM_OPTION_VALUES, READY_FOR_ADD} from "./productActionTypes";


export const setOptionValuesAction = (
    { isConfig, isFiltered, id, label, price, optionId, type }:
        {isConfig?: boolean, isFiltered?: boolean, id: number, label: string, price: string, optionId: number | string, type?: string}
) => {
    return {
        type: CUSTOM_OPTION_VALUES,
        payload: { id, label, price, optionId, type },
        meta: { isConfig, isFiltered }
    }
}

export const setCustomOptionOpenAction = ({ isOutsideClick, optionId }: {isOutsideClick?: boolean, optionId: number}) => {
    return {
        type: CUSTOM_OPTION_OPEN,
        payload: { optionId },
        meta: { isOutsideClick }
    }
}


export const setNotFilledOptionsAction = (array: number[]) => {
    return {
        type: READY_FOR_ADD,
        payload: array,
    }
}